import React, { Component } from "react";
import { Redirect } from 'react-router-dom';
import { Modal, Button, Form, Alert } from "react-bootstrap";
import moment from 'moment';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { validateJobEditForm } from "../utils/validation";
import CommonToast from "./Toaster/CommonToast";
import CommonLoader from "./loaderComponent/CommonLoader";


export default class JobEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: null,
      jobTitle: "",
      startDate: null,
      endDate: null,
      showAlert: false,
      errorMsg: "",
      done: false,
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
      loading: true
    };
  }

  componentDidMount() {

    // this.setState({ loading: true })
    // this.setState({
    //   id: this.props.data.id,
    //   jobTitle: this.props.data.jobTitle,
    //   startDate: moment(new Date(this.props.data.startDate)).toDate(),
    //   endDate: moment(new Date(this.props.data.endDate)).toDate(),
    //   departmentId: this.props.data.user.departmentId
    // })
    // this.setState({ loading: false })
    this.setState({ loading: true });
    if (this.props.data) {
      this.setState({
        id: this.props.data.id,
        jobTitle: this.props.data.jobTitle,
        startDate: this.props.data.startDate ? moment(this.props.data.startDate).toDate() : null,
        endDate: this.props.data.endDate ? moment(this.props.data.endDate).toDate() : null,
        departmentId: this.props.data.user?.departmentId || null,
        loading: false
      });
    } else {
      this.setState({ loading: false });
    }
  }



  handleChange = (event) => {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
    });
  };
  handleDateChange = (date, field) => {
    let errors = { ...this.state.errors };

    if (field === "startDate") {
      this.setState({
        startDate: date,
        targetDate: date,
        endDate: null,
        errors: { ...errors, startDate: undefined },
      });
    }

    if (field === "endDate") {
      if (date < this.state.targetDate) {
        errors.endDate = "End date must be on or after start date.";
      } else {
        delete errors.endDate;
      }

      this.setState({
        endDate: date,
        errors,
      });
    }
  };

  onSubmit = (e) => {
    this.setState({ loading: true });
    e.preventDefault();
    const errors = validateJobEditForm(
      this.state.jobTitle,
      this.state.startDate,
      this.state.endDate
    );
    let job = {
      jobTitle: this.state.jobTitle,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
    };
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }
    axios({
      method: 'put',
      url: `/jobs/${this.state.id}`,
      data: job,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })

      .then(res => {
        this.setState({
          completed: true,
          toastMessage: "Job updated successfully!",
          toastVariant: 'success',
          color: 'green',
          done: true,
          showToast: true,
        });

        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
          this.props.onHide();
        }, 2000);
        // this.props.history.push('/job-list')
        // this.setState({ done: true })
      })
      .catch(err => {

        this.setState({
          toastMessage: "Job update failed!",
          toastVariant: 'danger',
          color: 'red',
          showToast: true,
          loading: false
        });
        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 1000);
        // this.setState({
        //   showAlert: true, errorMsg: err.response.data.message
        // })
      });

  };

  render() {
    // const { showAlert, done } = this.state
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          <Modal
            {...this.props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                Edit Job
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={this.onSubmit}>
                {/* {done ? <Redirect to={{ pathname: '/job-list', state: { selectedDepartment: this.state.departmentId } }} /> : <></>}
            {showAlert ? (
              <Alert variant="alert alert-warning" className="m-1">
                {this.state.errorMsg}
              </Alert>) : (<></>)
            } */}
                <Form.Group controlId="formJobTitle">
                  <Form.Label className="mb-2 required">Job Title</Form.Label>
                  <Form.Control
                    type="text"
                    className="col-12"
                    name="jobTitle"
                    value={this.state.jobTitle}
                    onChange={this.handleChange}
                    autoComplete="off"

                  />
                  <span className="login-error">
                    {this.state.errors.jobTitle && <small className="text-danger">{this.state.errors.jobTitle}</small>}
                  </span>
                </Form.Group>
                <Form.Group controlId="formStartDate">
                  <Form.Label className="mb-2 required">Job Start Date</Form.Label>
                  {/* <DatePicker
                    selected={this.state.startDate}
                    onChange={startDate => this.setState({ startDate: startDate })}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    name="startDate"
                    dateFormat="yyyy-MM-dd"
                    className="form-control ml-1"
                    placeholderText="Select Start Date"
                    autoComplete="off"

                  /> */}
                  <DatePicker
                    selected={this.state.startDate}
                    className="form-control "
                    dateFormat="dd/MM/yyyy"
                    onChange={date => this.handleDateChange(date, 'startDate')}
                    placeholderText="Select start date"
                    minDate={new Date(new Date().getFullYear(), new Date().getMonth(), 1)}
                  />
                  <span className="login-error">
                    {this.state.errors.startDate && <small className="text-danger">{this.state.errors.startDate}</small>}
                  </span>
                </Form.Group>
                <Form.Group controlId="fromEndDate">
                  <Form.Label className="mb-2 required">Job End Date</Form.Label>
                  {/* <DatePicker
                    selected={this.state.endDate}
                    onChange={endDate => this.setState({ endDate: endDate })}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    name="endDate"
                    dateFormat="yyyy-MM-dd"
                    className="form-control ml-1"
                    placeholderText="Select Start Date"
                    autoComplete="off"

                  /> */}
                  <DatePicker
                    selected={this.state.endDate}
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    onChange={date => this.handleDateChange(date, 'endDate')}
                    placeholderText="Select end date"
                    minDate={this.state.targetDate || this.state.startDate}
                    disabled={!this.state.startDate || !this.state.targetDate}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                  <span className="login-error">
                    {this.state.errors.endDate && <small className="text-danger">{this.state.errors.endDate}</small>}
                  </span>
                </Form.Group>
                <Button variant="outline-primary" type="submit" className="mt-2">
                  Submit
                </Button>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.props.onHide}>Close</Button>
            </Modal.Footer>
          </Modal>
        </CommonLoader>
      </>
    );
  }
}